import { put } from "@/shared/api/api-client";
import { injectable } from "inversify";

@injectable()
export class BuyerAccount {
    async editBuyerAccount(dto: {
        name: string,
        address: string,
        inn: string,
        ogrn: string,
        // phone: string,
        // email: string,
    }) {
        const res = await put(`${PUBLIC_API_URL}/edit_company`, { ...dto });
        return res;
    }
}